import {JsonProperty} from 'json-typescript-mapper';
import {Marketday} from './marketday.model';
import {Contact} from './contact.model';
import {Salesunit} from './salesunit.model';

export class Contract {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('merchantNumber')
  public merchantNumber?: string;

  @JsonProperty('marketdayNumber')
  public marketdayNumber?: number;

  @JsonProperty('marketdateNumber')
  public marketdateNumber?: number;

  @JsonProperty('startDate')
  public startDate?: string;

  @JsonProperty('endDate')
  public endDate?: string;

  @JsonProperty('boothWidth')
  public boothWidth?: number;

  @JsonProperty('boothDepth')
  public boothDepth?: number;

  @JsonProperty('contractNumber')
  public contractNumber?: string;

  @JsonProperty('contractNumberInternal')
  public contractNumberInternal?: string;

  @JsonProperty('boothWidthAdditional')
  public boothWidthAdditional?: number;

  @JsonProperty('boothDepthAdditional')
  public boothDepthAdditional?: number;

  @JsonProperty('specialPrice')
  public specialPrice?: number;

  @JsonProperty('divergentEnergy')
  public divergentEnergy?: boolean;

  @JsonProperty('energyAdvancedPayment')
  public energyAdvancedPayment?: number;

  @JsonProperty('isSpecial')
  public isSpecial?: boolean;

  @JsonProperty('boothWidthWinter')
  public boothWidthWinter?: number;

  @JsonProperty('boothDepthWinter')
  public boothDepthWinter?: number;

  @JsonProperty('boothWidthWinterAdditional')
  public boothWidthWinterAdditional?: number;

  @JsonProperty('boothDepthWinterAdditional')
  public boothDepthWinterAdditional?: number;

  @JsonProperty('energyType')
  public energyType?: string;

  @JsonProperty('energyTypeWinter')
  public energyTypeWinter?: string;

  @JsonProperty({clazz: Marketday, name: 'marketday'})
  public marketday?: number;

  @JsonProperty({clazz: Contact, name: 'merchant'})
  public merchant?: number;

  @JsonProperty({clazz: Salesunit, name: 'salesunit'})
  public salesunit?: Salesunit;

  @JsonProperty('useWinterSize')
  public useWinterSize?: boolean;

  @JsonProperty('useAdditionalWinterSize')
  public useAdditionalWinterSize?: boolean;

  constructor() {
    this.id = void 0;
    this.merchantNumber = void 0;
    this.marketdayNumber = void 0;
    this.marketdateNumber = void 0;
    this.startDate = void 0;
    this.endDate = void 0;
    this.boothWidth = void 0;
    this.boothDepth = void 0;
    this.contractNumber = void 0;
    this.contractNumberInternal = void 0;
    this.boothWidthAdditional = void 0;
    this.boothDepthAdditional = void 0;
    this.specialPrice = void 0;
    this.divergentEnergy = void 0;
    this.energyAdvancedPayment = void 0;
    this.isSpecial = void 0;
    this.boothWidthWinter = void 0;
    this.boothDepthWinter = void 0;
    this.boothWidthWinterAdditional = void 0;
    this.boothDepthWinterAdditional = void 0;
    this.energyType = void 0;
    this.energyTypeWinter = void 0;
    this.marketday = void 0;
    this.merchant = void 0;
    this.salesunit = void 0;
    this.useWinterSize = void 0;
    this.useAdditionalWinterSize = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/contract.model.ts